import { CONSTRUCTS } from '../../../utils/constructs'
import { getDataForChart } from '../../../utils/reactChartConfig'
import { convert1to6ToPercent } from '../../../utils/statisticCalc'

/**
 * called by ResultsModule4.js
 * @param jtLabels, object, 'label' portion of the jsonText object from Redux
 * @param modNpoAnswers, object, latest NPO survey answers for current module
 * @param benchMod, object, benchmark of either this NPO category or of all NPOs
 * @param modResults, object, the latest results of the user's organization with respect to above benchmark (percentiles)
 * @param benchType, string, benchmark chartType, either 'cat' or 'all'
 * @param yearlyComp, object, containing all the info and data for a yearly comparison (or null)
 * @param chartType, string, either 'summary' (overall result) or the section name (not yet used)
 * @return object, the chart data for Module 4
 *
 * Note: for yearly comparison, we use the following variables slightly differently:
 * modNpoAnswers = benchmark, either for all NPOs ('all') or only the NPOs of the same category ('cat')
 * benchMod = last survey results
 * modResults = results of selected year's survey (or null)
 * benchType = always null
 */
export const getChartDataMod4 = (jtLabels, modNpoAnswers, benchMod, modResults, benchType, yearlyComp, chartType) => {
  if (yearlyComp) {
    modNpoAnswers = yearlyComp.benchmark
    benchMod = yearlyComp.lastSurveyResults
    modResults = yearlyComp.selectedSurveyResults
    benchType = null
  }
  let chartLabels, npoData, benchData, resultsData
  switch (chartType) {
    case 'summary':
      chartLabels = [  // the order here pertains only to the chart
        `${jtLabels[CONSTRUCTS.COMPLEXITY.name] || 'Complexity'}`.toUpperCase(),
        `${jtLabels[CONSTRUCTS.FUNDING_OPPORTUNITY.name] || 'Funding Opportunities'}`.toUpperCase(),
        `${jtLabels[CONSTRUCTS.HOSTILITY.name] || 'Hostility'}`.toUpperCase(),
        `${jtLabels[CONSTRUCTS.LATITUDE.name] || 'Latitude'}`.toUpperCase(),
      ]
      npoData = [
        modNpoAnswers?.KMP.mean,
        modNpoAnswers?.MUN.mean,
        modNpoAnswers?.HST.mean,
        modNpoAnswers?.FRE.mean,
      ]
      benchData = [
        benchMod?.KMP.mean,
        benchMod?.MUN.mean,
        benchMod?.HST.mean,
        benchMod?.FRE.mean,
      ]
      if (yearlyComp) resultsData = [
        modResults?.KMP.percentile,
        modResults?.MUN.percentile,
        modResults?.HST.percentile,
        modResults?.FRE.percentile,
      ]
      break
    default:
      console.error('No match found for chart chartType:', chartType)
  }

  return getDataForChart(jtLabels, chartLabels, npoData, benchData, resultsData, benchType, yearlyComp)
}
